import classNames from "classnames";
import styles from "./GridContainer.module.scss";

export interface GridContainerStyleProps {
  fullWidth?: boolean;
  verticalPadding?: boolean;
  noVertical?: boolean;
  noHorizontal?: boolean;
  horizontalSpacing?: "md" | "lg";
  className?: string;
  id?: string;
  noTopMargin?: boolean;
  navigationPage?: boolean;
}

interface GridContainerProps extends GridContainerStyleProps {
  children: React.ReactNode;
}

const GridContainer: React.FC<GridContainerProps> = ({
  children,
  fullWidth = false,
  verticalPadding = false,
  noVertical,
  noHorizontal,
  className,
  id,
  horizontalSpacing = "md",
  noTopMargin = false,
  navigationPage = false,
}) => {
  return (
    <div className={styles.gridContainer}>
      <div
        className={classNames(styles.grid, className, {
          [styles.fullWidth]: fullWidth,
          [styles.verticalPadding]: verticalPadding,
          [styles.noVertical]: noVertical,
          [styles.noHorizontal]: noHorizontal,
          [styles.horizontalSpacingLarge]: horizontalSpacing === "lg",
          [styles.noTopMargin]: noTopMargin,
          [styles.navigationPage]: navigationPage,
        })}
        id={id}
      >
        {children}
      </div>
    </div>
  );
};

export default GridContainer;
